export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "worker.10960ed5.worker.js");
}
